export let TagTypes = /*#__PURE__*/function (TagTypes) {
  TagTypes["One"] = "1";
  TagTypes["Two"] = "2";
  TagTypes["Three"] = "3";
  return TagTypes;
}({});